import { useMemo } from 'react'
import useQueryParams from 'hooks/useQueryParams'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'

const ELIGIBLE_AD_GROUP_IDS: ReadonlySet<string> = new Set([
  '190284186892', // Gold Coast
  '190284187332', // Melbourne
  '190284185492', // Sydney
  '190284185972', // Perth
  '191291611824', // Phuket
  '191291616184', // Koh Samui
  '187326053997', // Noosa
  '190284185732', // Hamilton Island
  '191291618584', // Khao Lak
  '190284187372', // Port Douglas
  '190284187652', // Mornington Peninsula
])

function useSalesAndCtrRanking() {
  const query = useQueryParams()
  const utmAdgroup = query.get('utm_adgroup')

  const canActivate = useMemo(() => {
    return !!utmAdgroup && ELIGIBLE_AD_GROUP_IDS.has(utmAdgroup)
  }, [utmAdgroup])

  return useOptimizelyExperiment(OptimizelyExperiments.searchSalesCtrPaidTrafficRanking, canActivate)
}

export default useSalesAndCtrRanking
